<script setup lang="ts">
import { useBreadcrumb } from '~/composables/layout/useBreadcrumb';
import { useRoute } from '#imports';
import { notification } from 'ant-design-vue';

const {
  firstOptions,
  secondOptions,
  firstValue,
  secondValue,
  onChangeFirst,
  onChangeSecond,
  showSelects,
  breadcrumbItems,
} = useBreadcrumb();

const route = useRoute();

const shareUrl = async () => {
  try {
    const url = window.location.origin + route.fullPath
    await navigator.clipboard.writeText(url)

    notification.success({
      message: '링크가 복사되었습니다.',
      placement: 'top',
      duration: 3,
    })
  } catch (e) {
    notification.error({
      message: '링크 복사에 실패했습니다.',
      placement: 'top',
    })
  }
}

/**
 * 현재 페이지 인쇄 핸들러
 *
 * @params none
 * @return void  브라우저 기본 인쇄 다이얼로그 호출
 * @author utis
 * @see    window.print(), @media print 스타일로 세부 제어 가능
 */
const onClickPrint = (): void => {
  if (process.client) window.print();
};


</script>

<template>
  <div class="subpage-breadcrumb-box">
    <div class="container">
      <nav class="breadcrumb-wrap">
        <ol class="bread-list">
          <!-- 홈 -->
          <li class="bread-home">
            <NuxtLink to="/">
              <img src="~/assets/img/pc/sub/home.svg" alt="home" />
            </NuxtLink>
          </li>

          <!-- 1차 -->
          <li class="bread-first" v-if="showSelects">
            <a-select
                :value="firstValue"
                @change="onChangeFirst"
                :options="firstOptions.map(o => ({ value: o.value, label: o.label }))"
                class="bread-select"
            />
          </li>

          <!-- 2차 (children 이 없으면 비활성/숨김) -->
          <li class="bread-second" v-if="showSelects && secondOptions.length">
            <a-select
                :value="secondValue"
                @change="onChangeSecond"
                :options="secondOptions.map(option => ({
                value: option.value,
                label: option.label,
              }))"
                class="bread-select"
            />
          </li>
          <li v-else class="bread-first bread-title-only">
            <NuxtLink :to="'/etc/sitemap'" class="bread-only-link">
            <span class="bread-text">{{ breadcrumbItems[0]?.label || '사이트맵' }}</span>
            </NuxtLink>
          </li>
        </ol>
        <ol class="bread-btn-wrap">
          <li>
            <a-button type="link" @click="shareUrl">
              <img src="~/assets/img/pc/sub/share.svg" alt="share" />
            </a-button>
          </li>
          <li>
            <a-button type="link" @click="onClickPrint">
              <img src="~/assets/img/pc/sub/print.svg" alt="print" />
            </a-button>
          </li>
        </ol>
      </nav>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use 'breadcrumb.scss';
</style>